/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import styled from 'styled-components';

export const FooterControls = styled.div`
  position: sticky;
  bottom: 0;
  background-color: var(--cds-layer-01);
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 1rem;
  padding: 1rem;
  border-top: 1px solid var(--cds-border-subtle-01);
`;

export const SelectionCount = styled.span`
  font-size: 0.95rem;
  color: #666;
`;
